import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import Layout from './layout';
import { formatImage } from '@ifeng-fe/public_method';

const handleVideoSlideData = data => {
    try {
        return data.slice(0, 5).map(
            item =>
                (item.type === 'web' && item.title.includes('http')
                    ? {
                          url: item.url,
                          title: item.title,
                          type: item.type,
                      }
                    : {
                          thumbnail: item.thumbnail ? formatImage(item.thumbnail, 475, 368) : item.thumbnail,
                          url: item.url,
                          title: item.title,
                      }),
        );
    } catch (error) {
        console.error(error);
    }

    return data;
};

/* eslint-disable */
allData.videoSlide = allData.videoSlide && handleVideoSlideData(allData.videoSlide);
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
